<template>
    <footer>
        <cookie-law theme="simply-owners">
            <div slot="message">
                This website uses cookies to ensure you get the best experience on our website. <a class="underline" href="/privacy-policy">Learn more & Opt out</a>
            </div>
        </cookie-law>
    </footer>
</template>

<script>
import CookieLaw from "vue-cookie-law";

export default {
    name: "CookieComponent.vue",
    components: { CookieLaw }
}
</script>
<style>
.Cookie--simply-owners {
    background: #424851;
    color: #fff;
    padding: 1.25em;
}

.Cookie--simply-owners .Cookie__button {
    background: #486521;
    padding: 0.625em 3.125em;
    color: #fff;
    border-radius: 0;
    border: 0;
    font-size: 1em;
}

.Cookie--simply-owners .Cookie__button:hover {
    background: #7ebf36;
}
</style>
